import { LanguageCode } from 'client/types';

const SETTING_CONTENT_RU = `1. Скачайте приложение [название вашего приложения] из Google Play или App Store
2. Зарегистрируйтесь или авторизуйтесь в приложении [название вашего приложения], выбрав регион Россия
3. Настройте устройства [наименование бренда устройств] в приложении [название вашего приложения]
4. Войдите в приложение Дом с Алисой
5. В приложении Дом с Алисой нажмите кнопку "+"
6. Выберите "Устройство умного дома"
7. Выберите [название этого навыка] из списка производителей
8. Нажмите "Объединить аккаунты"
9. Авторизуйтесь, используя данные учетной записи [название вашего приложения] из шага 2`;

const SETTING_CONTENT_EN = `1. Download [your app name] app from Google Play or App Store
2. Register or log in to [your app name] application
3. Connect and set up [your device brand name] devices in the [your app name] app
4. Log in to Yango Play app
5. Scroll down to Smart Home section and tap "Manage smart home"
6. Tap "+" button in Smart Home
7. Select "Smart Home Device"
8. Select [your skill name] from the list of manufacturers
9. Tap "Merge Accounts"
10. Log in using the [your app name] account details from step 2`;

const SETTING_CONTENT_AR = `1. قم بتحميل تطبيق Yango Play من متجر تطبيقات Google Play أو App Store
2. سجّل الدخول أو قم بإنشاء حساب جديد في تطبيق Yango Play
3. قم بتوصيل وإعداد أجهزة [اسم العلامة التجارية لجهازك] في تطبيق Yango Play
4. سجّل الدخول في تطبيق Yango Play
5. انتقل إلى قسم المنزل الذكي وانقر على "إدارة المنزل الذكي"
6. انقر على إشارة "+" الموجودة في أعلى الشاشة
7. اختر "جهاز المنزل الذكي"
8.  اختر [اسم المهارة] من قائمة الشركات المصنعة
8. اختر " دمج الحسابات "
10. سجّل الدخول باستخدام معلومات حساب Yango Play التي أدخلتها في الخطوة 2`;

export const DEFAULT_EXTERNAL_DESCRIPTION: Record<LanguageCode, string> = {
    ar: SETTING_CONTENT_AR,
    en: SETTING_CONTENT_EN,
    ru: SETTING_CONTENT_RU,
};
